import React,{useEffect, useState} from 'react'
import { TextField, Button, Typography, Paper } from "@material-ui/core";
import FileBase from "react-file-base64";
import { useDispatch ,useSelector} from "react-redux";
import { createPost, updatePost } from "../../reduxStore/actions/posts";


import useStyles from "./style"



const Form = ({ currentId, setCurrentId }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const user = JSON.parse(localStorage.getItem('profile'));

    const [postData, setPostData] = useState({  title:'', message:'', tags:'', selectedFile:''});

    //if updated post is equal to post in database then set in form 
    const post = useSelector((state)=> currentId ? state.posts.find((p) => p._id = currentId): null);

     // setting update data in form 
    useEffect(() => {
        if(post) setPostData(post);
    },[post])

    const handleSubmit = (e) =>{
        e.preventDefault();

        //  gerting name of current logged in user and then sending to backend for post or any action 
        if(currentId){
            dispatch(updatePost(currentId, {...postData, name: user?.result?.name}));
        }else{
            dispatch(createPost({...postData, name: user?.result?.name}));
        }
        clear();
    };

    if(!user?.result?.name){
        return(
            <Paper className={classes.paper}>
               <Typography variant="h6" align="center">
                 Please Sign In to create your own memories and like othere's memories
               </Typography>
            </Paper>
        )
    }


    const clear = () =>{
        setCurrentId(null);
        setPostData({  title:'', message:'', tags:'', selectedFile:''});

    };

    return (
       <Paper className={classes.paper}>
          <form autoComplete="off" noValidate className={ `${classes.form} ${classes.root} ` } onSubmit={handleSubmit}>
               <Typography varient="h6"> {currentId ? `Upating`:`Creating`} a Memories</Typography>
               
               <TextField name="title" variant="outlined"  label="Title" fullWidth value={postData.title} onChange={(e) => setPostData({ ...postData, title:e.target.value })}/>
               <TextField name="message" variant="outlined" label="Message" fullWidth value={postData.message} onChange={(e) => setPostData({ ...postData, message:e.target.value })}/>
               <TextField name="tags" variant="outlined" label="Tags" fullWidth value={postData.tags} onChange={(e) => setPostData({ ...postData, tags:e.target.value .split(',') })}/>
                
                <div className={classes.fileInput}>
                   <FileBase
                       type="file"
                       multiple={false}
                       onDone={({ base64 }) => setPostData({...postData, selectedFile:base64})} 
                   />
                </div>

                <Button className={classes.buttonSubmit} variant="contained" color="primary" size="large" type="submit" fullWidth >Submit</Button>
                <Button  variant="contained" color="secondary" size="small" onClicl={clear} fullWidth >Clear</Button>
          </form>

       </Paper>
    )
}

export default Form
